<template lang="pug">
v-container(fluid px-0 fill-height class=" tw-items-start tw-content-start tw-overflow-x-hidden")
  kubiqa-website-themes-theme-d-components-shared-top-navigation
  v-row(
    align="end"
    justify="center"
    class="header tw-z-0 pt-0 mt-0"
    :style="website.pages.home.background_image ? { backgroundImage: `url(${path(website.pages.home.background_image)})` } : ''"
  )
    v-col
      v-row(no-gutters justify="space-between")
        v-col(cols="6" class="")
          div(class="tw-grid")
            div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1")
              kubiqa-website-shared-widget-editor(
                page="home"
                placement="call_out"
                @content="(content) => (content != null ? ((defaultCallout = false), key++) : ((defaultCallout = true), key++))"
              )
            div(v-if="defaultCallout" :key="key" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
              div(class="tw-h-full  tw-items-center tw-flex")
                v-row(no-gutters justify="center")
                  v-col(cols="9")
                    span(class="tw-font-bold tw-text-white tw-text-2xl") Find your ideal home
        v-col(cols="5" class="")
          kubiqa-website-themes-theme-d-components-shared-floating-search-bar
      v-row
        v-col(class="tw-h-16")

  v-row(no-gutters align="center" justify="space-around" class="  mt-10 ")
    v-col(cols="11" class="description-container tw-rounded-md")
      div(class="tw-grid")
        div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1")
          kubiqa-website-shared-widget-editor(
            page="home"
            placement="description"
            @content="(content) => (content != null ? ((defaultDescription = false), key++) : ((defaultDescription = true), key++))"
          )
        div(v-if="defaultDescription" :key="key" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
          div(class="tw-h-full  tw-items-center tw-flex")
            v-row(no-gutters justify="center")
              v-col(cols="9")
                span(class="tw-font-bold tw-text-white tw-text-2xl") Description
  kubiqa-website-themes-theme-d-components-home-listings
  v-row(class="tw-pt-24 ")
    v-col
  kubiqa-website-themes-theme-d-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      key: 0,
      defaultCallout: null,
      defaultDescription: null,
    };
  },
  computed: {
    website() {
      return this.$store.getters['website/website'];
    },
  },
};
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
.font-poppins {
  font-family: 'Poppins', sans-serif !important;
}
.description-container {
  background-color: #fdf3f2;
}
</style>
